import { useContext } from "react"
import { useVoice } from "../context/voice/VoiceContext"
import Button from "../formfields/Button"
import { GlobalContext } from "../GlobalContext"


type Props = {

}

function VoiceModeToggle({ }: Props) {


    const {
        isListening,
        isRecognizerRunning,
        speechRecognitionSupported,
        isListeningEnabled,
        setIsListeningEnabled
    } = useVoice()

    const { isRTL, t, sendMessageToWebsocket } = useContext(GlobalContext)

    if (!speechRecognitionSupported()) {
        return null
    }

  

    const logVoiceModeToggle = (voiceModeEnabled: boolean) => {
        // log voice mode usage stats while we decide whether to port it to app-mobile
        sendMessageToWebsocket(JSON.stringify({
            action: "checklistsClientApp",
            subAction: "logVoiceModeToggle",
            voiceModeEnabled
        }))
    }

    return <Button
        onClick={() => {
            logVoiceModeToggle(!isListeningEnabled)
            if (isListeningEnabled) {
                setIsListeningEnabled(false)
                localStorage.setItem('savedVoiceOption', 'no')
            } else {
                setIsListeningEnabled(true)
                localStorage.setItem('savedVoiceOption', 'yes')
            }
        }}
        text={isListeningEnabled ? 
            t('SharedComponents.VoiceModeToggle.disable') : 
            t('SharedComponents.VoiceModeToggle.enable')}
        variant={isListeningEnabled ? `white` : `primary`}
        align={isRTL ? 'right' : 'left'}
        size={'big'}
    />

}

export default VoiceModeToggle